import Vue from 'vue';
import Vuetify from 'vuetify/lib';

require(/* webpackPrefetch: true */ '@mdi/font/css/materialdesignicons.css');

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: false,
  },
});
